export function pickTitleWordCounts(payload) {
  if (!payload || typeof payload !== "object") return null;

  const capturedWordCount = Number(payload.capturedWordCount);
  const masteredWordCount = Number(payload.masteredWordCount);
  const hasCaptured = Number.isFinite(capturedWordCount);
  const hasMastered = Number.isFinite(masteredWordCount);
  if (!hasCaptured && !hasMastered) return null;

  const counts = {};
  if (hasCaptured) {
    counts.capturedWordCount = Math.max(0, Math.round(capturedWordCount));
  }
  if (hasMastered) {
    counts.masteredWordCount = Math.max(0, Math.round(masteredWordCount));
  }
  return counts;
}
